import { Flex, SlideFade, VStack, SimpleGrid, Fade, Box, BoxProps } from '@chakra-ui/react'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { use100vh } from 'react-div-100vh'
import * as React from 'react'

import { LayoutContext } from '../../context/LayoutContext'
import { vw } from '../../styles/theme'
import ButtonHamburger from '../buttons/ButtonHamburger'
import ButtonSoundS from '../buttons/ButtonSoundS'
import ButtonTextNav from '../buttons/ButtonTextNav'
import Link from '../common/Link'
import Logo from '../icons/Logo'
import LogoNipponPaint from '../icons/LogoNipponPaint'
import LogoPaintWonder from '../icons/LogoPaintWonder'
import SVG from '../common/SVG'
import usePageColor from '../../hooks/usePageColor'

export type NavSPProps = BoxProps & {}

const NavSP: React.FC<NavSPProps> = ({ ...others }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const ref = React.useRef<HTMLElement>()
  const h100vh = use100vh()
  const color = usePageColor()

  const { state } = React.useContext(LayoutContext)

  const handleClick = () => {
    setIsOpen(false)
  }

  React.useEffect(() => {
    if (isOpen) {
      disableBodyScroll(ref.current)
    } else {
      clearAllBodyScrollLocks()
    }
  }, [isOpen])

  return (
    <>
      <Box pos="relative" {...others}>
        {state.initializeFinished && (
          <ButtonHamburger
            pos="fixed"
            zIndex="99999"
            top={vw(15)}
            right={vw(15)}
            isOpen={isOpen}
            onClick={() => setIsOpen(!isOpen)}
          />
        )}
        <Fade in={isOpen} unmountOnExit={true} w="100%" h="100%">
          <Box ref={ref} w="100vw" minH="100vh" bg="rgba(255,255,255,0.9)" boxSizing="border-box" color={color}>
            <SlideFade
              in={isOpen}
              unmountOnExit={true}
              w="100%"
              h="100%"
              offsetY={vw(20)}
              transition={{
                enter: { duration: 0.5, delay: 0.1 },
              }}
            >
              <Box p={`${vw(62)} ${vw(38)}`} h={h100vh}>
                <Flex h="100%" flexDirection="column" justifyContent="space-between">
                  <Box>
                    <SVG svg={<Logo />} w={vw(300)} />
                  </Box>
                  <SimpleGrid columns={2} spacingY={vw(20)}>
                    <ButtonTextNav onClick={handleClick} to="/" ja="トップ" en="TOP" />
                    <ButtonTextNav onClick={handleClick} to="/about/" ja="AYDAとは" en="ABOUT" />
                    <ButtonTextNav onClick={handleClick} to="/award/" ja="アワード情報" en="AWARD" />
                    <ButtonTextNav onClick={handleClick} to="/entry/" ja="結果発表" en="RESULT" />
                    <ButtonTextNav onClick={handleClick} to="/internship/" ja="インターンシップ" en="INTERNSHIP" />
                    <ButtonTextNav onClick={handleClick} to="/summit/" ja="アジア学生サミット" en="SUMMIT" />
                    <ButtonTextNav onClick={handleClick} to="/event/" ja="アーカイブ" en="ARCHIVE" />
                    <ButtonTextNav
                      onClick={handleClick}
                      to="https://twitter.com/ayda_japan/"
                      ja="twitter"
                      en="ayda_japan"
                    />
                  </SimpleGrid>
                  <Box>
                    <VStack fontSize={vw(10)} align="flex-start" spacing={vw(15)}>
                      <ButtonSoundS color={color} />
                      <Link to="mailto:ayda@kenchiku.co.jp">お問い合わせ</Link>
                      <Link onClick={handleClick} to="/privacypolicy/">
                        プライバシーポリシー
                      </Link>
                      <Link onClick={handleClick} to="/snspolicy/">
                        ソーシャルメディアポリシー
                      </Link>
                    </VStack>
                    <VStack mt={vw(46)} align="stretch" spacing={vw(15)}>
                      <SVG svg={<LogoPaintWonder />} w={vw(115)} />
                      <Link to="https://www.nipponpaint-holdings.com/">
                        <SVG svg={<LogoNipponPaint />} w={vw(240)} />
                      </Link>
                    </VStack>
                  </Box>
                </Flex>
              </Box>
            </SlideFade>
          </Box>
        </Fade>
      </Box>
    </>
  )
}

export default NavSP
